import React from 'react';

import * as S from './styles';

type ItemRowProps = {
  name?: string | undefined | null;
  type?: string;
  icon?: string | null;
  subtitle?: React.ReactNode;
};

const ItemRow = ({ name, type, icon, subtitle }: ItemRowProps) => {
  const alternativeIcon = () => {
    switch (type) {
      case 'AlertSearch':
        return <S.SearchIcon />;
      default:
        return <S.CreateListIcon size={40} />;
    }
  };

  return (
    <S.ItemRow>
      <S.Icon border={type === 'AlertSearch'}>
        {icon && name ? <S.Image alt={name} src={icon} /> : alternativeIcon()}
      </S.Icon>
      <S.Info>
        <S.Name
          truncate={type === 'ListCategory'}
          bold={type === 'ListCategory'}
        >
          {name}
        </S.Name>
        <S.Count>{subtitle}</S.Count>
      </S.Info>
    </S.ItemRow>
  );
};

export default ItemRow;
